import React from "react";
import {Colors, Container, Text} from "../../../ui";
import {formatCurrency} from "../../../helpers";
import {IconCopy} from "../../bounce-ui";

interface IGuestPaymentLink {
  url: string;
  handleCopyLink: () => void;
  totalBalance: number;
}

const ContributionLink = ({handleCopyLink, url, totalBalance}: IGuestPaymentLink) => {
  if (!url) {
    return null;
  }
  return (
    <>
      <Text size={14}>You can share the following contribution link to let loved ones help with your debt.</Text>
      <Container
        fullWidth
        onClick={handleCopyLink}
        row
        sx={{
          border: `solid 1px ${Colors.grey._300}`,
          borderRadius: "5px",
          padding: "2px 12px",
          justifyContent: "space-between",
          backgroundColor: Colors.bw.white,
        }}
      >
        <Text
          size={16}
          sx={{
            textOverflow: "ellipsis",
            width: "300px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            color: Colors.grey._500,
          }}
        >
          {url}
        </Text>
        <IconCopy style={{width: "20px", height: "20px"}} />
      </Container>
      <Text
        size={14}
      >{`They can securely contribute any amount. To pay off the full balance, have them enter ${formatCurrency(
        totalBalance
      )}`}</Text>
    </>
  );
};

export default ContributionLink;
